import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './CategoryPage.css';
import CategoryManagement from './CategoryManagement/CategoryManagement';
import {
  requestAllCategories,
  requestCategoriesCampaign,
} from 'services/actions/adminActions';
import withViewSize from '../../../HOC/withViewSize/withViewSize';
import { selectOrderedCategories } from '../../../selectors/adminSelectors';

const CategoryPage = ({
  categories,
  campaigns,
  fetching,
  viewSize,
  getAllCategories,
  getCategoriesCampaign,
}) => {
  return (
    <div className={viewSize}>
      <div className="category-page page-row">
        <CategoryManagement
          categories={categories}
          campaigns={campaigns}
          fetching={fetching}
          getAllCategories={getAllCategories}
          getCategoriesCampaign={getCategoriesCampaign}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: selectOrderedCategories(state),
  campaigns: state.adminState.campaigns,
  fetching: state.adminState.fetchingCategoriesCampaign,
  viewSize: state.viewState.viewSize,
});

const mapDispatchToProps = {
  getAllCategories: requestAllCategories,
  getCategoriesCampaign: requestCategoriesCampaign,
};

export default compose(
  withViewSize,
  connect(mapStateToProps, mapDispatchToProps)
)(CategoryPage);
